<template>
  <v-col cols="12" >
    <div v-if="sites.length > 0"><v-card v-for="item in sites" :key="item._id" class="mt-3">
      <v-card-title>{{ item.name }}</v-card-title>
      <v-card-text>
        <v-row class="d-flex">
        <v-col cols="12" sm="6">
          <v-card height="100%">
            <v-card-title>Общая информация</v-card-title>
            <v-card-text>
              URL: <a :href="item.url" target="_blank">{{ item.url }}</a> <br>
              Город: {{ item.city.name }} <br>
              Часовой пояс: {{ item.timeZoneText }}<br>
              <template v-if="item.mainPhone">
                Телефон: {{ item.mainPhone }} <br>
              </template>
              <template v-if="item.organization.name && false">
                Организация: {{item.organization.name}} <br>
              </template>
              <template v-if="item.organization.address">
                Адрес: {{item.organization.address}} <br>
              </template>
              <template v-if="item.organization.email">
                Email: {{item.organization.email}} <br>
              </template>
              <template v-if="item.organization.vkUrl">
                ВКонтакте: <a :href="item.organization.vkUrl" target="_blank">{{ item.organization.vkUrl }}</a><br>
              </template>
              <template v-if="item.organization.instagramUrl">
                Instagram: <a :href="item.organization.instagramUrl" target="_blank">{{ item.organization.instagramUrl }}</a><br>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
        
        <v-col cols="12" sm="6" v-for="rent in item.rentDeals" :key="rent._id">
        <v-card>
          <v-card-title>Договор №{{ rent._num }}</v-card-title>
          <v-card-text>
            Срок действия: {{ rent.startedAt | localDate }} - {{ rent.finishedAt | localDate }}
            <v-badge inline dot color="green" v-if="rent._isActive"></v-badge>
            <br>
            Ставка аренды: {{ rent.costPerMonth }} руб/мес. <br>
            <v-form>
            <v-text-field
              v-model="rent._notifySms"
              label="SMS-оповещение"
              filled
              :prefix="rent._phoneNumberPrefix"
              @focus="rent._phoneNumberPrefix = '+7'"
              @blur="rent._notifySms || (rent._phoneNumberPrefix = '')"
              v-mask="'##########'"
              :rules="[v => !v || (v.length == 10) || 'Введите правильный номер.']"
              :append-icon="isAvailableSms(rent) ? 'mdi-checkbox-marked-circle' : ''"
              @click:append="saveSms(rent)"
            >
            </v-text-field> 

            <v-text-field
              v-model="rent._notifyEmail"
              label="Email-оповещение"
              filled
              :rules="[v => !v || isEmail(v) || 'Введите правильный email.']"
              :append-icon="isAvailableEmail(rent) ? 'mdi-checkbox-marked-circle' : ''"
              @click:append="saveEmail(rent)"
            >
            </v-text-field>

            </v-form>
          </v-card-text>
        </v-card>
        </v-col>
        </v-row>
      </v-card-text>
    </v-card></div>
    <div v-else>
      <v-alert class="mt-3" type="warning" outlined dense>
        В настоящий момент у вас нет сайтов, подключенных к платформе.
      </v-alert>
      <v-alert class="mt-3" type="success" outlined dense>
        Свяжитесь с администратором, чтобы подключить сайт в вашем городе и начать получать поток клиентов: <br>
        +7 926 032 07 97 (Алексей).
      </v-alert>
    </div>
  </v-col>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'partner-sites',

  data() {
    return {
      
    }
  },

  methods: {
    isAvailableSms(rent) {
      return rent._notifySms && (rent._notifySms.length == 10) && (rent._notifySms != rent.notifySms);
    },
    isAvailableEmail(rent) {
      return rent._notifyEmail && this.isEmail(rent._notifyEmail) && (rent._notifyEmail != rent.notifyEmail);
    },
    saveSms(rent) {
      this.$store.dispatch('sites/updateNotify', { rent, updateType: 'sms'})
      .then(res => {
        this.$store.dispatch('showMessage', res.message);
      });
    },
    saveEmail(rent) {
      this.$store.dispatch('sites/updateNotify', { rent, updateType: 'email'})
      .then(res => {
        this.$store.dispatch('showMessage', res.message);
      });
    },
  },

  computed: {
    ...mapState('sites', ['sites']),
    ...mapGetters('sites', ['loadingUpdateNotify'])
  }
}
</script>